export const ALERT_COLORS = {
  primary: '#151515',
  secondary: '#808080',
  tertiary: '#B4B4B4'
};